import React from 'react';
import { useSelector } from 'react-redux';
import { ArcStack, ArcText } from '@src/core/ui';
import { GAMEPAD_MESSAGE } from '../../constants';
import { useJoystick } from '@src/features/order/pages/take-off-to-en-route-page/hooks';
import { selectJoystickStatus, selectJoystickId } from '../../redux';

interface ChecklistGamepadMessageProps {
  serialNumber?: string;
}

const ChecklistGamepadMessage: React.FC<ChecklistGamepadMessageProps> = ({ serialNumber }) => {
  // Use hook to check joystick connection
  const { connected, joystickId } = useJoystick(serialNumber, false);
  
  // Also get from Redux to show saved status
  const savedConnected = useSelector(selectJoystickStatus(serialNumber || ''));
  const savedJoystickId = useSelector(selectJoystickId(serialNumber || ''));
  
  // Use current connection status or saved status
  const isConnected = connected || savedConnected;
  const displayJoystickId = joystickId || savedJoystickId;

  if (isConnected && displayJoystickId) {
    return (
      <ArcStack>
        <ArcText.caption color='success' fontSize={12} textAlign='center'>
          {displayJoystickId} is connected
        </ArcText.caption>
      </ArcStack>
    );
  }

  return (
    <ArcStack>
      <ArcText.caption color='brand.main' fontSize={12} textAlign='center'>
        {GAMEPAD_MESSAGE}
      </ArcText.caption>
    </ArcStack>
  );
};

export default ChecklistGamepadMessage;

